<template>
    <div>
        <v-btn color="primary" @click="toggleChat">{{ $t('common.chat.action') }}</v-btn>
        <chat-dialog v-if="showChat" @close="closeChat" :setup="setup" />
        <v-overlay :value="showChat" @click="closeChat"></v-overlay>
    </div>
</template>

<script>
import ChatDialog from '@/components/chat/ChatDialog'

export default {
    props: ['setup'],
    components: {
        ChatDialog
    },
    data () {
        return {
            showChat: false
        }
    },
    methods: {
        toggleChat () {
            this.showChat = !this.showChat
        },
        closeChat () {
            this.showChat = false
        }
    }
}
</script>
